<template>
  <div
    id="Menu2"
    class="overflow-auto overflow-auto bg-white instrumentsAndAccessoiresMenu"
    v-if="isVisible"
  >
    <div class="row ">
      <div class="col-md-12 col-lg-6 ">
        <div v-for="video in videoList" :key="video.productImgUrl">
          <div class="row productAccessoirsImgWrapper">
            <div class="col-3">
              <img :src="video.productImgUrl" :style="video.style" />
            </div>
            <div class="col-9 text-left">
              <p class="fontp text-left" v-html="$t(video.productInfo)"></p>
              <button
                class="instrumentsAndAccessoiresMenu__button text-decoration-none bg-transparent border-0"
                data-fancybox
                data-width="800"
                data-height="450"
                :href="video.videoUrl"
              >
                <img
                  src="@/assets/images/button_filme_instrumente.png"
                  class="instrumentsAndAccessoiresMenu__button-image"
                />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 col-lg-6  text-left">
        <div id="accordion">
          <Collapse
            v-for="product in productList"
            :key="product.headline"
            :headline="product.headline"
            :dropDownElements="product.dropDownElements"
            :id="product.id"
          />
          <LabeledButton
            :label="$t('Go_to_instruments')"
            :onClick="
              () => {
                toggle('Menu1');
              }
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LabeledButton from "@/components/LabeledButton";
import Collapse from "./Collapse";
import { languageAdapter } from "@/services/languageAdapter";
import { createVimeoMetadataUrl } from "@/services/urlBuilder.js";

export default {
  name: "InstrumentsMenu2",
  props: {
    toggle: Function,
    isVisible: Boolean
  },
  components: {
    Collapse,
    LabeledButton
  },
  mounted() {
    this.videoUrls.forEach(element => {
      this.getUrlForVideo(Object.keys(element)[0]);
    });
  },
  data() {
    return {
      productList: [
        {
          id: "collapseOne",
          headline: "acc_main_filter_catridge_protection",
          dropDownElements: [
            { productNr: "20321-022", productInfo: "prefilter" },
            { productNr: "20323-004", productInfo: "water_trap" }
          ]
        },
        {
          id: "collapseTwo",
          headline: "acc_laparascopic_simultaneous_application",
          dropDownElements: [
            { productNr: "20323-003", productInfo: "lap_tubing_set_3m" },
            { productNr: "20323-006", productInfo: "lap_tubing_set_5m" },
            { productNr: "20323-005", productInfo: "t_piece" }
          ]
        },
        {
          id: "collapseThree",
          headline: "acc_open_surgical_application",
          dropDownElements: [
            { productNr: "20321-004", productInfo: "evacuation_tube" },
            { productNr: "20321-009", productInfo: "evacuation_tubing_22m" },
            { productNr: "20321-010", productInfo: "evacuation_funnel_22m" },
            {
              productNr: "20321-012",
              productInfo: "evacuation_tubing_22m_reusable"
            }
          ]
        },
        {
          id: "collapseFour",
          headline: "acc_connection_central_evacuation_system",
          dropDownElements: [
            {
              productNr: "20323-001",
              productInfo: "evacuation_element_central_evacuation"
            },
            { productNr: "20323-009", productInfo: "smoke_evacuation_tubing" }
          ]
        },
        {
          id: "collapseFive",
          headline: "attachment_sets",
          dropDownElements: [
            {
              productNr: "20180-132",
              productInfo: "fastening_set_IES_to_vio_cart"
            },
            {
              productNr: "20323-008",
              productInfo: "fastening_set_vio_c_to_IES3"
            },
            {
              productNr: "20323-007",
              productInfo: "fastening_set_IES3_to_vio3"
            }
          ]
        },
        {
          id: "collapseSix",
          headline: "acc_activation_options",
          dropDownElements: [
            {
              productNr: "20323-002",
              productInfo: "automatic_activation_device"
            },
            { productNr: "20322-101", productInfo: "one_pedal_foodswitch" }
          ]
        }
      ],

      videoUrls: [
        { water_trap: "" },
        { automatic_activation_device: "" },
        { t_piece: "" },
        { connection_central_evacuation_system: "" },
        { lap_tubing_set: "" },
        { pedal_footswitch: "" }
      ],

      videosWithoutLanguage: this.$store.getters.getForCertainLanguage()
    };
  },
  computed: {
    videoList() {
      return [
        {
          productImgUrl: this.$store.getters.image_zubehoer_wasserfalle,
          videoUrl: this.videoUrls["water_trap"],
          productInfo: "filter_protection",
          style: ""
        },
        {
          productImgUrl: this.$store.getters
            .image_zubehoer_aktivierungsvorrichtung,
          videoUrl: this.videoUrls["automatic_activation_device"],
          productInfo: "automatic_device_activation",
          style: "width:110%; margin-left:-30px;"
        },
        {
          productImgUrl: this.$store.getters.image_zubehoer_t_stueck,
          videoUrl: this.videoUrls["t_piece"],
          productInfo: "t_piece_evacuation",
          style: "width:160%; margin-left:-30px;"
        },
        {
          productImgUrl: this.$store.getters.image_zubehoer_zentralabsaugung,
          videoUrl: this.videoUrls["connection_central_evacuation_system"],
          productInfo: "central_evacuation_system_connection",
          style: "width:140%; margin-left:-40px;"
        },
        {
          productImgUrl: this.$store.getters.image_zubehoer_lapschlauch,
          videoUrl: this.videoUrls["lap_tubing_set"],
          productInfo: "lap_tubing_set_view",
          style: "width:130%; margin-left:-30px;"
        },
        {
          productImgUrl: this.$store.getters.image_zubehoer_fussschalter,
          videoUrl: this.videoUrls["pedal_footswitch"],
          productInfo: "one_pedal_footswitch",
          style: "width:110%; margin-left:-20px;"
        }
      ];
    }
  },
  methods: {
    async getUrlForVideo(key) {
      const video = this.videosWithoutLanguage[key];
      if (this.$store.state.isPwaModeActive) {
        this.videoUrls[key] = createVimeoMetadataUrl(video) + ".mp4";
      } else {
        this.videoUrls[key] = `https://player.vimeo.com/${video.vimeoId}`;
      }
    }
  }
};
</script>

<style scoped>
.instrumentsAndAccessoiresMenu__button {
  color: black;
  padding: 0;
  margin-top: 0.5rem;
}
.instrumentsAndAccessoiresMenu__button-image {
  max-width: 45px;
}
.productAccessoirsImgWrapper {
  margin-bottom: 40px;
}
.labeledbutton {
  float: right;
}
</style>
